"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonBase = void 0;
var react_1 = __importDefault(require("react"));
var util_1 = require("../../util");
function ButtonBase(props) {
    var Component = props.component, innerRef = props.innerRef, onClick = props.onClick, onLoadingChange = props.onLoadingChange, rest = __rest(props, ["component", "innerRef", "onClick", "onLoadingChange"]);
    var startLoading = function () {
        onLoadingChange && onLoadingChange(true);
    };
    var stopLoading = function () {
        onLoadingChange && onLoadingChange(false);
    };
    var handleClick = function (event) {
        if (onClick) {
            var promise = onClick(event);
            if (util_1.isPromise(promise)) {
                startLoading();
                promise.finally(function () { return stopLoading(); });
            }
        }
    };
    return (react_1.default.createElement(Component, __assign({ ref: innerRef, onClick: handleClick, type: Component === 'button' ? 'button' : undefined }, rest)));
}
exports.ButtonBase = ButtonBase;
ButtonBase.defaultProps = {
    component: 'button',
};
//# sourceMappingURL=ButtonBase.js.map